import applogger from '@applogger'
let pageMixin
let formMixin
let asyncData

// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  // No-op
}
else {
  asyncData = ({store, route, router}) => {
    applogger.debug('generic webform asyncData starting')
    return store.dispatch('node/load', {nid: route.path, type: route.type, cacheOptions: {scope: 'global'}})
      .then(node => {
        // TODO: We need to find another way to manage the page titles.
        // title = node.title
        let p = []
        p.push(store.dispatch('blob/load', {blobID: `page-blob-top--node-${node.nid}`}))
        p.push(store.dispatch('blob/load', {blobID: `page-blob-bottom--node-${node.nid}`}))
        return Promise.all([node, Promise.all(p)])
      })
      .then(([node, loaders]) => {
        applogger.debug('generic webform asyncData completed')
        return {
          itemid: node.nid,
          title: node.title
        }
      })
      .catch(err => {
        applogger.error('An error occurred loading the page.')
        switch (err.response.status) {
        case 403:
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 403 })
          break
        case 404:
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 404 })
          break
        default:
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 500 })
          break
        }
      })
  }

  pageMixin = {
    mounted: function() {
      if (!this.configValid) {
        this.$store.dispatch('reportError', {
          type: 'error',
          title: 'Webform field mapping missing',
          text: 'Webform field mapping is missing or could not be loaded. Please contact the Administrator to report the problem.',
          notification: true,
          showClose: true,
          timeout: 6000
        })
      }
    },
    created: function() {
      this.fieldMap = this.$registry.getModuleSetting('webform', this.itemid) || {}
      this.configValid = (Object.keys(this.fieldMap).length > 0)
    },
    computed: {
      itemid: function() {
        return this.item ? this.item.nid : null
      },
      notpublished: function() {
        return (parseInt(this.item.status) !== 1)
      },
      attachedView: function() {
        return this.$store.getters['node/getAttachedView'](this.item.nid)
      },
      hasBody: function() {
        return (this.item.body && this.item.body.length > 0)
      },
      item: function() {
        if (this.nid !== false) {
          return this.$store.getters['node/getByNID'](this.nid)
        }
        else if (this.$route.params.nid !== undefined && !isNaN(parseFloat(this.$route.params.nid)) && isFinite(this.$route.params.nid)) {
          return this.$store.getters['node/getByNID'](this.$route.params.nid)
        }
        else {
          return this.$store.getters['node/getByPath'](this.$route.path)
        }
      },
      listItems: function() {
        return []
      },
      components: function() {
        return Object.values(this.item.webform.components) || []
      }
    },
    methods: {
      submitWebform(formData) {
        let webformData = {
          id: this.nid,
          save_draft: false,
          data: {}
        }

        if (this.configValid) {
          webformData.data = Object.entries(this.fieldMap).map(([fieldname, cid]) => ({
            cid: cid,
            value: formData[fieldname] || ''
          }))
        }
        else {
          // If there is no fieldMap configured for this webform, use the components of the node itself
          // For this to work, it requires the components' form_key values to have the exact same name
          // as the formData fields
          webformData.data = this.components.map(component => ({
            cid: component.cid,
            value: formData[component.form_key] || ''
          }))
        }

        this.$store.getters['getGraphQLClient']().query({ query: 'query { accesstoken(tokentype: "webform") }' })
          .then(response => response.data.accesstoken)
          .then(accesstoken => this.$store.getters['getGraphQLClient']().query({
            query: `
              mutation submitWebForm($form: WebFormDataInput!) {
                submitWebForm(form: $form) {
                  sid
                  redirect
                }
              }`,
            variables: {
              form: webformData
            },
            context: {
              headers: {
                'X-Access-Token': accesstoken
              }
            }
          }))
          .then((response) => {
            if (response.data.submitWebForm.redirect) {
              this.$router.push({path: response.data.submitWebForm.redirect})
            }
          })
      }
    }
  }

  formMixin = {
    data() {
      return {
        formData: {
          fullname: null,
          phone: null,
          email: null,
          message: null,
          enquiryType: null
        },
        enquiryTypes: {
          question: 'Question',
          sales: 'Sales',
          distribution: 'Distribution',
          feedback: 'Feedback'
        }
      }
    },
    computed: {
      disabled() {
        if (!this.configValid) {
          return true
        }
        else if (this.formData.message && this.formData.fullname && this.formData.email && this.formData.enquiryType && this.validateEmail(this.formData.email)) {
          return false
        }
        else {
          return true
        }
      }
    },
    methods: {
      validateEmail(email) {
        // eslint-disable-next-line no-useless-escape
        let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regex.test(String(email).toLowerCase())
      }
    }
  }
}

// eslint-disable-next-line no-undef
pageMixin.computed.drupalmode = () => APPSETTINGS.DataStore.store === 'drupal'
// eslint-disable-next-line no-undef
pageMixin.computed.icmsmode = () => APPSETTINGS.DataStore.store === 'ichabodcms'

export default pageMixin
export {
  asyncData,
  pageMixin,
  formMixin
}
